import { jsx as _jsx } from "react/jsx-runtime";
export function TableBody({ children }) {
    return (_jsx("tbody", { className: "divide-y divide-border-subtle", children: children }));
}
